
import { ITreeviewChuongTrinhDaoTaoFocusedValue } from "../../../components-data/treeview-ctdt/TreeviewChuongTrinhDaoTao";
import { IChuongTrinhDaoTaoCopyMonRequest } from "../../../model/request/ctdt/IChuongTrinhDaoTaoCopyMonRequest";
import { IChuongTrinhDaoTaoCopyRequest } from "../../../model/request/ctdt/IChuongTrinhDaoTaoCopyRequest";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IChuongTrinhDaoTao } from "../../../model/respone/ctdt/IChuongTrinhDaoTao";
import { IChuongTrinhDaoTaoViewModel } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eChuongTrinhDaoTaoActionsObj = {
    LOAD_START: "",
    LOAD_SUCCESS: {} as IChuongTrinhDaoTaoViewModel[],
    LOAD_ERRR: "",
    CHANGE_CTDT_SELECTED: {} as IChuongTrinhDaoTaoViewModel | undefined,
    SHOW_EDIT_MODEL: {} as IChuongTrinhDaoTaoViewModel | undefined,
    CLOSE_EDIT_MODEL: undefined,
    SAVE_START: {} as IChuongTrinhDaoTao,
    SAVE_SUCCESS: {} as IChuongTrinhDaoTao,
    SAVE_ERROR: "",
    DELETE_START: {} as IIdsRequest,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    OPEN_COPY_MODAL: {} as ITreeviewChuongTrinhDaoTaoFocusedValue | undefined,
    CLOSE_COPY_MODAL: undefined,
    COPY_CHANGE_CHUONG_TRINH_GOC: {} as ITreeviewChuongTrinhDaoTaoFocusedValue,
    COPY_CHANGE_CHUONG_TRINH_DICH: {} as ITreeviewChuongTrinhDaoTaoFocusedValue,
    COPY_CHANGE_CREATE_NEW: {} as boolean,
    COPY_START: {} as IChuongTrinhDaoTaoCopyRequest,
    COPY_SUCCESS: undefined,
    COPY_ERROR: "",

    UPLOAD_MODAL_OPEN: {} as IChuongTrinhDaoTaoViewModel,
    UPLOAD_MODAL_CLOSE: undefined,

    COPY_CLIPBOARD_DATA: {} as IChuongTrinhDaoTaoCopyMonRequest,

    PASTE_CLIPBOARD_DATA_START: {} as IChuongTrinhDaoTaoCopyMonRequest,
    PASTE_CLIPBOARD_DATA_SUCCESS: undefined,
    PASTE_CLIPBOARD_DATA_ERROR: "",

    LOAD_ALL_START: undefined,
    LOAD_ALL_SUCCESS: {} as IChuongTrinhDaoTaoViewModel[],
    LOAD_ALL_ERROR: "",

    UPDATE_TOTAL_TIN_CHI_START: {} as IIdsRequest,
    UPDATE_TOTAL_TIN_CHI_SUCCESS: undefined,
    UPDATE_TOTAL_TIN_CHI_ERROR: "",

    UPDATE_LOCK_STATUS_START: {} as IChuongTrinhDaoTao,
    UPDATE_LOCK_STATUS_SUCCESS: undefined,
    UPDATE_LOCK_STATUS_ERROR: "",
};
export const eChuongTrinhDaoTaoActionIds = generateActionTypeIds(
    eChuongTrinhDaoTaoActionsObj,
    "CHUONG_TRINH_DAO_TAO"
);
export type IChuongTrinhDaoTaoActionTypes = IGenericActionType<
    typeof eChuongTrinhDaoTaoActionsObj,
    "CHUONG_TRINH_DAO_TAO"
>;
